import { apiFetch } from './client';

export interface Partner {
  id: string;
  code: string;
  displayName: string;
  status: string;
  egressAllowlistNote: string | null;
  notes: string | null;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface PartnerListResponse {
  partners: Partner[];
  total: number;
}

export interface PartnerFilters {
  search?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface CreatePartnerPayload {
  code: string;
  displayName: string;
  status?: string;
  egressAllowlistNote?: string;
  notes?: string;
}

export interface UpdatePartnerPayload {
  displayName?: string;
  status?: string;
  egressAllowlistNote?: string;
  notes?: string;
}

const buildQuery = (params: Record<string, string | number | boolean | undefined>): string => {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) query.set(key, String(value));
  }
  const qs = query.toString();
  return qs ? `?${qs}` : '';
};

export const partnersApi = {
  list: (filters: PartnerFilters = {}): Promise<PartnerListResponse> => {
    const qs = buildQuery(filters as Record<string, string | number | boolean | undefined>);
    return apiFetch<PartnerListResponse>(`/partners${qs}`);
  },

  get: (id: string): Promise<Partner> => {
    return apiFetch<Partner>(`/partners/${id}`);
  },

  create: (data: CreatePartnerPayload): Promise<Partner> => {
    return apiFetch<Partner>('/partners', { method: 'POST', data });
  },

  update: (id: string, data: UpdatePartnerPayload): Promise<Partner> => {
    return apiFetch<Partner>(`/partners/${id}`, { method: 'PUT', data });
  },

  remove: (id: string): Promise<{ message: string }> => {
    return apiFetch<{ message: string }>(`/partners/${id}`, { method: 'DELETE' });
  },
};
